// Документы живут в /info/ — старые адреса /docs/… уводит middleware/docs-redirect.ts,
// поэтому ссылки сразу ведут на конечный адрес, без редиректа
export const DOCS_PATH = '/info' // Документы
export const SALE_RULES_PATH = DOCS_PATH + '/sale-rules' // Правила продажи
export const PRIVACY_POLICY_PATH = DOCS_PATH + '/privacy-policy' // Обработка персональных данных

export const COMPANY_PATH = '/company'
export const ABOUT_PATH = COMPANY_PATH + '/about'
export const REQUISITES_PATH = COMPANY_PATH + '/requisites'
export const CONTACTS_PATH = COMPANY_PATH + '/contacts'

export const PERSONAL_PATH = '/personal'
export const ORDERS_PATH = PERSONAL_PATH + '/orders'
export const PROFILE_PATH = PERSONAL_PATH + '/profile'
export const BONUSES_PATH = PERSONAL_PATH + '/bonuses'
export const PERSONAL_REVIEWS_PATH = PERSONAL_PATH + '/reviews'

export const FAVOURITES_PATH = '/favourites'
export const COMPARE_PATH = '/compare'
export const CART_PATH = '/cart'
export const CART_ADD_PATH = CART_PATH + '/add'

export const ORDER_PATH = '/order'

export const ORDER_PAY_PATH = ORDER_PATH + '/pay'

export const CATALOG_PATH = '/catalog'

export const SEARCH_PATH = CATALOG_PATH + '/search' // Поиск

export const LOGOUT_PATH = '/logout'
export const LOGIN_PATH = '/login'
export const NEWS_PATH = '/news'
export const ACTIONS_PATH = '/actions'
export const STORES_PATH = '/stores'
export const VIDEO_PATH = '/video'
export const GALLERY_PATH = '/gallery'

export const BRANDS_PATH = '/brands'
export const COLLECTIONS_PATH = '/collections'

// Объявления (Трейд-Ин) — публичный раздел
export const ADS_PATH = '/ads'
export const getAdPath = (id: string | number) => `${ADS_PATH}/${id}`

// Объявления в личном кабинете
export const PERSONAL_ADS_PATH = PERSONAL_PATH + '/ads'
export const PERSONAL_ADS_ADD_PATH = PERSONAL_ADS_PATH + '/add'
export const getPersonalAdEditPath = (id: string | number) =>
  `${PERSONAL_ADS_PATH}/${id}/edit`
